"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BillingRule = class BillingRule extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    editing;
    onEditing(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("editing");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    labelAlign;
    metadata;
    async $$load_metadata() {
        return this.$app.repo.get('ui_metadata');
    }
    container;
    async $$load_container() {
        return {
            self: this.$fn.urlFor('create_object_by_type', { object_type: 'billing-rule' }),
            object: 'list',
            data: []
        };
    }
    resource;
    async $$load_resource() {
        return new this.$fn.Resource(this.item ? this.item : { rule_type: null, rule: {} });
    }
    ux;
    dataMembers = ['formId', 'formName', 'labelAlign', 'metadata', 'container', 'resource', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                formName: "billingRule",
                labelAlign: "right",
                metadata: null,
                container: null,
                resource: null,
                ux: null,
            },
        };
    }
    get ruleTypes() {
        if (this.loaded) {
            return this.metadata.billing_rule_type_options;
        }
        return null;
    }
    get editor() {
        if (this.loaded) {
            return this.editing ? this.resource.editor() : null;
        }
        return null;
    }
    get target() {
        if (this.loaded) {
            return this.editor || this.resource;
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_emit_2324_getActionArgs($event) {
        return {
            event: "saved",
            value: $event.data.response.data,
        };
    }
    async act_2248226175642056_rest_2322_getActionArgs($event) {
        return {
            method: "save",
            container: this.container,
            resource: this.editor,
        };
    }
    async evh_2248226175642056_submit(event, scope) {
        return await this.actions.evh_2248226175642056_submit.executeFromDOM(this, event, scope);
    }
    async act_6993263378944638_script_2326_getActionArgs_value($event) {
        this.$emit('cancelEdit');
    }
    async act_6993263378944638_script_2326_getActionArgs($event) {
        return {
            value: () => this.act_6993263378944638_script_2326_getActionArgs_value($event),
        };
    }
    async evh_6993263378944638_clickPreventStop(event, scope) {
        return await this.actions.evh_6993263378944638_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_2320 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_2319 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_2320,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_2319],
        });
        const act_2248226175642056_emit_2324 = new core_1.actions.EmitAction({
            actionArgs: this.act_2248226175642056_emit_2324_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_saved_2323 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_emit_2324,
            event: "saved",
            displayName: "emit",
        });
        const act_2248226175642056_rest_2322 = new core_1.actions.RestAction({
            actionArgs: this.act_2248226175642056_rest_2322_getActionArgs,
            displayName: "save",
            events: [evh_2248226175642056_saved_2323],
        });
        const evh_2248226175642056_submit_2321 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_rest_2322,
            event: "submit",
            displayName: "save",
        });
        const evh_2248226175642056_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_submit_2321],
        });
        const act_6993263378944638_script_2326 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6993263378944638_script_2326_getActionArgs,
            events: [],
        });
        const evh_6993263378944638_clickPreventStop_2325 = new core_1.actions.EventHandlerImpl({
            action: act_6993263378944638_script_2326,
            event: "click.prevent.stop",
            displayName: "script",
        });
        const evh_6993263378944638_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6993263378944638_clickPreventStop_2325],
        });
        return {
            act_7315092382398562_reloadComponentData_2320,
            evh_7315092382398562_reload_2319,
            evh_7315092382398562_reload,
            act_2248226175642056_emit_2324,
            evh_2248226175642056_saved_2323,
            act_2248226175642056_rest_2322,
            evh_2248226175642056_submit_2321,
            evh_2248226175642056_submit,
            act_6993263378944638_script_2326,
            evh_6993263378944638_clickPreventStop_2325,
            evh_6993263378944638_clickPreventStop,
            save: act_2248226175642056_rest_2322,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], BillingRule.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BillingRule.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], BillingRule.prototype, "editing", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('editing'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BillingRule.prototype, "onEditing", null);
BillingRule = __decorate([
    (0, vue_property_decorator_1.Component)()
], BillingRule);
exports.default = BillingRule;
vue_property_decorator_1.Vue.component("BillingRule", BillingRule);
